export default {
    wishlist: [],
}